export default {
    wishlist: [],
}